import { consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import { putProfileFailNotification } from './constants'
import { initialState } from './initialState'
import { MyProfileState } from './types'

// GET profile
const fetchProfileStart = (state): MyProfileState => ({
  ...state,
  isProfileLoading: true,
  isProfileLoaded: false,
  isProfileLoadingFailed: false,
})

const fetchProfileSuccess = (state, profile): MyProfileState => {
  if (profile)
    return {
      ...state,
      profile,
      isProfileLoading: false,
      isProfileLoaded: true,
    }
  return {
    ...state,
    isProfileLoading: false,
    isProfileLoaded: true,
  }
}

const fetchProfileFail = (state, error: Error): MyProfileState => {
  consoleEvents.error('Failed to fetch profile', error)
  return { ...state, isProfileLoadingFailed: true, isProfileLoading: false, isProfileLoaded: true }
}

// UPDATE Profile
const updateProfileStart = (state): MyProfileState => ({
  ...state,
  isProfileLoading: true,
  isProfileLoaded: false,
})

const updateProfileSuccess = (state, userName): MyProfileState => ({
  ...state,
  profile: { ...state.profile, userName },
  isProfileLoading: false,
  isProfileLoaded: true,
  isProfileLoadingFailed: false,
})

const updateProfileFail = (state, error: Error): MyProfileState => {
  consoleEvents.error('Failed to update profile', error)
  return { ...state, isProfileLoadingFailed: true, isProfileLoading: false, isProfileLoaded: false }
}

// UPLOAD IMAGE
const uploadImageStart = (state): MyProfileState => ({
  ...state,
  isUploadingImageLoading: true,
  hasUploadingImageSuccess: false,
})

const uploadImageSuccess = (state, imageUrl: string): MyProfileState => ({
  ...state,
  profile: {
    ...state.profile,
    image: imageUrl,
  },
  hasUploadingImageSuccess: true,
  isUploadingImageLoading: false,
  hasUploadingImageFailed: false,
})

const uploadImageFailed = (state, error: Error): MyProfileState => {
  consoleEvents.error('Failed to upload image', error)
  return {
    ...state,
    hasUploadingImageSuccess: false,
    isUploadingImageLoading: false,
    hasUploadingImageFailed: true,
  }
}

const resetImageUploadStatus = (state): MyProfileState => {
  return {
    ...state,
    hasUploadingImageSuccess: false,
    isUploadingImageLoading: false,
    hasUploadingImageFailed: false,
  }
}

// HANDLE notifications

const addNotification = (state): MyProfileState => {
  const notifications = [putProfileFailNotification]

  return {
    ...state,
    notifications,
  }
}

const resetNotifications = (state): MyProfileState => ({
  ...state,
  notifications: [],
})

const reducer = createReducer((on) => {
  on(actions.fetchProfileStart, fetchProfileStart)
  on(actions.fetchProfileSuccess, fetchProfileSuccess)
  on(actions.fetchProfileFail, fetchProfileFail)
  on(actions.updateProfileStart, updateProfileStart)
  on(actions.updateProfileSuccess, updateProfileSuccess)
  on(actions.updateProfileFail, updateProfileFail)
  on(actions.uploadImageStart, uploadImageStart)
  on(actions.uploadImageSuccess, uploadImageSuccess)
  on(actions.uploadImageFailed, uploadImageFailed)
  on(actions.uploadImageFailed, uploadImageFailed)
  on(actions.resetImageUploadStatus, resetImageUploadStatus)
  on(actions.addNotification, addNotification)
  on(actions.resetNotifications, resetNotifications)
}, initialState)

export default reducer
